import React from 'react';
import { CreditCard, ExternalLink } from 'lucide-react';
import type { StripeCardPaymentMethod } from '../../lib/billingApi';

function formatBrand(brand: string) {
  const b = brand.toLowerCase();
  if (b === 'amex') return 'American Express';
  return b.charAt(0).toUpperCase() + b.slice(1);
}

export function PaymentMethodCard(props: {
  paymentMethod: StripeCardPaymentMethod | null;
  loading: boolean;
  onManage: () => void;
}) {
  const { paymentMethod, loading, onManage } = props;

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <CreditCard className="w-4 h-4 text-gray-700" />
          <h4 className="font-semibold text-black">Payment Method</h4>
        </div>
        <button
          onClick={onManage}
          className="px-3 py-1.5 rounded-md bg-gray-100 hover:bg-gray-200 text-gray-800 text-sm font-medium flex items-center gap-2"
        >
          <ExternalLink className="w-4 h-4" />
          <span>{paymentMethod ? 'Update' : 'Add'}</span>
        </button>
      </div>

      {loading ? (
        <div className="animate-pulse">
          <div className="h-4 bg-gray-200 rounded w-1/2 mb-2" />
          <div className="h-3 bg-gray-200 rounded w-1/3" />
        </div>
      ) : paymentMethod ? (
        <div className="text-sm text-gray-700">
          <div className="font-medium text-black">
            {formatBrand(paymentMethod.card.brand)} •••• {paymentMethod.card.last4}
          </div>
          <div className="text-gray-600 mt-1">
            Expires {String(paymentMethod.card.exp_month).padStart(2, '0')}/{String(paymentMethod.card.exp_year).slice(-2)}
          </div>
        </div>
      ) : (
        <div className="text-sm text-gray-600">
          No payment method on file. Add one to avoid any interruption to service.
        </div>
      )}
    </div>
  );
}


